import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { StatistiquesrapportComponent } from './components/statistiquesrapport/statistiquesrapport.component';
import { CertificatDetailModalComponent } from './components/certificat-detail-modal/certificat-detail-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EnvoiMailModalComponent } from './components/envoi-mail-modal/envoi-mail-modal.component';

@NgModule({
  declarations: [
    StatistiquesrapportComponent,
    CertificatDetailModalComponent,
    EnvoiMailModalComponent,
  ],
  imports: [CommonModule, SharedModule, MatTooltipModule],
  exports: [StatistiquesrapportComponent],
})
export class RapportModule {}
